import React from 'react';
import {Heading, Text, Box, Grid, GridItem, useBreakpointValue} from '@chakra-ui/react';
import PropTypes from 'prop-types';


const DataBanner = ({dataBanner}) => {
    const isMobile = useBreakpointValue({base: true, md: false});

    DataBanner.propTypes = {
        dataBanner: PropTypes.shape({
            title: PropTypes.string.isRequired,
            data: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    value: PropTypes.string.isRequired
                })).isRequired
        }),
    };

    return (
        <GridItem colStart={isMobile ? 1 : 1} colEnd={isMobile ? 5 : 10}
                  mt={isMobile ? "30px" : "100px"} mb={isMobile ? "30px" : "100px"} pt="75px" pb="75px"
                  ml="calc(50% - 50vw)" mr={0}
                  className='data-banner'
                  style={{
                      background: '#f4f7fe',
                      backgroundImage: `url('https://static.siminn.is/investors/endOfYearReports/2023/bubbleBackground.png')`,
                      backgroundSize: '100% auto',
                      backgroundPosition: 'center bottom',
                      backgroundRepeat: 'no-repeat',
                      width: isMobile ? '100vw' : "100vw",
                      minHeight: "463px"
                  }} spacing={3} align="stretch">
            <Grid
                templateColumns={`repeat(${isMobile ? 4 : 12}, 1fr)`}
                columnGap={isMobile ? "24px" : "32px"}
                rowGap={isMobile ? "40px" : "70px"}
                pl={isMobile ? "16px" : "48px"}
                pr={isMobile ? "16px" : "48px"}
            >
                <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 11}>
                    <Heading variant="heading3" className="column-1-10">{dataBanner.title}</Heading>
                </GridItem>
                <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 11} mb={isMobile ? "20px" : ""}>
                    <Grid
                        templateColumns={`repeat(${isMobile ? 4 : 9}, 1fr)`}
                        columnGap={isMobile ? 5 : 10}
                        rowGap={isMobile ? 20 : 10}
                        p={isMobile ? 0 : 0}>
                        {dataBanner.data.map((item, index) => (
                            <GridItem key={index} colSpan={3}>
                                <Box p={0}>
                                    <Text className="data-label" mb="20px">{item.label}</Text>
                                    <Text className="data-descriptor">{item.value}</Text>
                                </Box>
                            </GridItem>
                        ))}
                    </Grid>
                </GridItem>
            </Grid>
        </GridItem>
    );
};

export default DataBanner;